import React from "react";
import { ColorRing } from "react-loader-spinner";
const CircleLoader = () => {
  return (
    <ColorRing
      visible={true}
      height="80"
      width="80"
      ariaLabel="blocks-loading"
      wrapperStyle={{}}
      wrapperClass="blocks-wrapper"
      colors={["#0071E3", "#EAF2FF", "#0071E3", "#EAF2FF", "#0058C2"]}
    />
  );
};

export default CircleLoader;
